export function canUpdateDeliveryAddress({
  actor = "provider",
  surtido = false,
  collectionState = null,
  hasSuccessfulDelivery = false,
}) {
  if (hasSuccessfulDelivery === true) return false;
  if (actor === "admin") return true;
  if (actor !== "provider") return false;

  return surtido !== true && collectionState !== "recibida";
}
